import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import PropTypes from 'prop-types';

/**
 * Shared scaffold for the small DSV confirm/edit dialogs (Delete draft, Edit
 * version number, ...). Centralises the DS Modal header/body/footer slots and
 * the standard Cancel button so each concrete modal only supplies its title,
 * body content and primary action (and an optional DS header icon).
 */
function DsvModalShell({ visible, hide, icon, title, cancelLabel = 'Cancel', actions, children }) {
	return (
		<Modal visible={visible} close={hide} dismissClickOutsideModal={false}>
			<ModalHeader icon={icon}>
				<ModalTitle>{title}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					{children}
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<button className="dsv-btn dsv-btn--ghost" onClick={hide}>{cancelLabel}</button>
					{actions}
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
}

DsvModalShell.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
	icon: PropTypes.node,
	title: PropTypes.node,
	cancelLabel: PropTypes.string,
	actions: PropTypes.node,
	children: PropTypes.node,
};

export default DsvModalShell;
